import { z } from 'zod';

export const InsuranceOrganizationSchema = z.object({
  id: z.number(),
  name: z.string(),
  logo_url: z.string(),
  point_id: z.string(),
});

export const InsuranceOrganizationProductSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  is_primary: z.boolean(),
  price: z.number(),
  period: z.number(),
  organization: InsuranceOrganizationSchema,
});
